import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function useFeeData() {
  const [members, setMembers] = useState([]);
  const [payments, setPayments] = useState([]);
  const [overdueMap, setOverdueMap] = useState({});

  const load = useCallback(async () => {
    const [m, p] = await Promise.all([api.get("/members"), api.get("/fees")]);
    setMembers(m.data);
    setPayments(p.data);
    try {
      const od = await api.get("/fees/overdue");
      setOverdueMap(Object.fromEntries(od.data.map((x) => [x.id, x])));
    } catch (err) {
      toast.error("Could not load overdue fee status");
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  return { members, payments, overdueMap, load };
}
